import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import OfferReporter from '@/features/buybox/components/OfferReporter.vue';
import UpcomingBox from '@/components/upcoming/UpcomingBox.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import BuyBoxTypeSwitcher from '@/features/buybox/components/BuyBoxTypeSwitcher.vue';

import { UpcomingRelease } from '@/@types/graphql-types';
import { extractBuyboxOffers, isTitleSeason } from '@/helpers/title-helper';
import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { useListActions } from '@/helpers/composables/useListActions';
import { useBuyBoxData } from '@/features/buybox/composables/useBuyboxData';
import { BuyBoxFilterOptions } from '@/stores/useUserStoreTypes';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpcomingContent',
  props: {
    parentTitle: null,
    title: null,
    isTitleInWatchlist: { type: Boolean, default: true },
    showBuyBoxTypeSwitcher: { type: Boolean, default: false },
    additionalContexts: { default: () => [] },
    upcomingEpisodeReleases: { default: null }
  },
  setup(__props: any) {

const props = __props as { parentTitle: TitleDetail, title: TitleDetail, isTitleInWatchlist: boolean, showBuyBoxTypeSwitcher: boolean, additionalContexts: SnowplowContext[], upcomingEpisodeReleases: UpcomingRelease[] | null };

const NoOfferBell = () => import('@/features/buybox/components/grid/NoOfferBell.vue');



const { isLoggedIn } = storeToRefs(useUserStore());
const { setInWatchlist, onIsLoggedInChange } = useListActions();

const buyboxUpcomingReleases = computed(() => props.upcomingEpisodeReleases ?? props.title.content.upcomingReleases);

const { upcomingReleases } = useBuyBoxData({
	title: () => props.title,
	buyboxFilter: BuyBoxFilterOptions.ALL,
	buyboxUpcomingReleases,
});

const titleDetails = computed(() => {
	return {
		title: props.parentTitle.content.title,
		objectType: props.parentTitle.objectType,
		objectId: props.parentTitle.objectId,
		seasonNumber: isTitleSeason(props.title) ? props.title?.content?.seasonNumber : undefined,
	} as const;
});

watch(
	() => isLoggedIn.value,
	() => {
		if (!isLoggedIn.value) return;

		onIsLoggedInChange(props.parentTitle.id, titleDetails.value, props.isTitleInWatchlist, 'upcomingbox');
	},
	{ immediate: true }
);

function onNotifyMe() {
	setInWatchlist(props.parentTitle.id, props.isTitleInWatchlist, titleDetails.value, {
		source: 'upcomingbox',
	});
}

return { __sfc: true,NoOfferBell, props, isLoggedIn, setInWatchlist, onIsLoggedInChange, buyboxUpcomingReleases, upcomingReleases, titleDetails, onNotifyMe, OfferReporter, UpcomingBox, BuyBoxTypeSwitcher }
}

})